<template>
  <div>
    <PageTitle
      featureName="customers"
      functionName="List"
      :pageName="$options.name"
    />

    <v-container fluid>
      <v-card v-if="customerList.length > 0">
        <v-card-title><div class="subtitle-2">Customers</div></v-card-title>
        <v-card-text>
          <CustomerListItemCard
            v-for="item in customerList"
            :key="item.CustomerId"
            :item="item"
            @edit="customerListItemEditEvent"
          />
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog
      persistent
      v-model="showCustomerEditorDialog"
      :width="feature.customers.dialogWidth"
    >
      <CustomerEditor
        :isDialogOpen="showCustomerEditorDialog"
        :customerId="selectedCustomerId"
        @close="CustomerEditorCloseEvent"
        @update="CustomerEditorUpdateEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { todayISOString } from '@/use/DateFormatter'
import CustomerEditor from '@/components/Customer/CustomerEditor'
import CustomerListItemCard from '@/components/Customer/CustomerListItemCard'
import { userData } from '../store/UserSession'
export default {
  name: 'CustomersPage',
  components: {
    CustomerEditor,
    CustomerListItemCard
  },
  setup() {
    const customerList = ref([])
    const showCustomerEditorDialog = ref(false)
    const selectedCustomerId = ref()

    const customerListItemEditEvent = CustomerId => {
      selectedCustomerId.value = CustomerId
      showCustomerEditorDialog.value = true
    }

    const CustomerEditorCloseEvent = () => {
      showCustomerEditorDialog.value = false
    }

    const CustomerEditorUpdateEvent = () => {
      showCustomerEditorDialog.value = false
      refreshSearch()
    }

    const editRecurringCustomerEvent = () => {}

    const initForm = () => {
      refreshSearch()
    }

    const refreshSearch = async () => {
      const rq = {
        Criteria: {
          LoginName: userData.value.LoginName,
          UserId: userData.value.UserId,
          ServiceDate: todayISOString()
        }
      }
      const rs = await host.customer.list(rq)
      if (rs.InfoList.length > 0) {
        customerList.value = rs.InfoList
      }
    }

    initForm()

    return {
      feature,
      icon,
      customerList,
      refreshSearch,
      selectedCustomerId,
      customerListItemEditEvent,
      CustomerEditorCloseEvent,
      CustomerEditorUpdateEvent,
      editRecurringCustomerEvent,
      showCustomerEditorDialog
    }
  }
}
</script>

<style lang="scss" scoped></style>
